<template>
    <custom-dialog width="400px" :showClose="true" title="收费" v-if="visibleObj.chargeDialog"
        :visible="visibleObj.chargeDialog" @close="dialogVisible('chargeDialog')">
        <div class="charge-warp" slot="content">
            <div class="content-price"><span class="price-icon">¥</span>{{ dialogObj.price }}</div>
            <div class="payWay">
                <div @click="activeType = item.value"
                    :class="activeType == item.value ? 'payWay-item active' : 'payWay-item'" v-for="item in payWayList"
                    :key="item.value">
                    <img :src="item.icon" class="img-icon">
                    <div class="item-label">{{ item.label }}</div>
                </div>
            </div>
        </div>
        <div class="btns" slot="footer">
            <custom-button v-if="showCancelPayBtn" size="small" type="info" @click="cancelPayingStatusHandle">取消支付</custom-button>
            <custom-button size="small" type="info" @click="dialogVisible('chargeDialog')">取消</custom-button>
            <custom-button size="small" type="default-primary" v-if="computeDate"
                @click="chargeAndSign">收费并签到</custom-button>
            <custom-button size="small" type="primary" @click="charge">收费</custom-button>
        </div>
    </custom-dialog>
</template>
  
<script>
import customDialog from '@/components/customDialog/CustomDialog.vue'
import { Utils } from '@/utils/utils'
import { CommonDTO } from '@/DTO/index'
import target from '../../../../../vue.config'
import { isNull } from '../../../../utils/validateBase'
export default {
    // 定义引入的组件
    components: { customDialog },
    props: {
        visibleObj: {
            type: Object,
            default: {}
        },
        dialogObj: {
            type: Object,
            default: {}
        },
        showCancelPayBtn: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            payWayList: [],
            activeType: ''
        }
    },
    //变量监听
    watch: {},
    computed: {
        //计算就诊时间是否为今天
        computeDate() {

            if (Utils.eq(this.$moment(this.dialogObj.schedulingTime).startOf('day').valueOf(), this.$moment().startOf('day').valueOf())) {
                return true;
            } else {
                return false;
            }
        },
    },
    // 页面初始化
    async created() {
        let PAY_WAY = await CommonDTO.getPayWay()
        this.payWayList = PAY_WAY.filter(item => { return  item.value != '7'  })  //过滤掉医保支付
        if(this.$session.get('user').companyId == 10){
          this.payWayList = this.payWayList.filter(item => { return  item.value != '1'  })
        }
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 关闭
         */
        dialogVisible(name) {
            this.$emit("close", name);
        },
        /**
         * 收费
         */
        charge() {
            if (isNull(this.activeType)) return this.$message.error('请选择支付方式')
            this.$emit('updateData', { payWay: this.activeType, userAuthCode: '' })
        },
        /**
         * 收费并签到
         */
        chargeAndSign() {
            if (isNull(this.activeType)) return this.$message.error('请选择支付方式')
            this.$emit('chargeAndSign', { payWay: this.activeType, userAuthCode: '' })
        },

        // 取消支付中的状态
        cancelPayingStatusHandle() {
          this.$emit('cancelPayingStatusHandle')
        }
    },
}
</script>
<style lang="less" scoped src="./index.less"></style>